import React, { useState, useEffect } from "react"
import IncidentHeatmapReportCard, { MetricTagIcon, MetricClockIcon, MetricAlertIcon } from "../../../components/ui/heat-map-xl"
import { computeEngagementHeatmap } from "../../../utils/engagementHelpers"

const RANGE_OPTIONS = [
  { key: "7d", label: "Last 7 Days" },
  { key: "30d", label: "Last 30 Days" },
  { key: "90d", label: "Last 90 Days" },
]

const EngagementHeatmapSection = ({ orgId }) => {
  const [range, setRange] = useState("30d")
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!orgId) return
    setLoading(true)
    computeEngagementHeatmap(orgId, range).then((result) => {
      setData(result)
      setLoading(false)
    })
  }, [orgId, range])

    if (loading || !data) {
    return <div className="h-96 bg-muted rounded-2xl animate-pulse mb-6" />
  }

  const METRIC_ICONS = { "avg-session": MetricTagIcon, "peak-hour": MetricClockIcon, dropoff: MetricAlertIcon }
  const metricItemsWithIcons = data?.metricItems?.map((item) => {
    const IconComponent = METRIC_ICONS?.[item?.id]
    return { ...item, icon: IconComponent ? <IconComponent fill={item?.trendColor} /> : null }
  })

  return (
    <div className="mb-6">
      <h2 className="text-lg font-semibold text-foreground mb-1">Engagement Heatmap</h2>
      <p className="text-sm text-muted-foreground mb-4">Which days and times your learners are most active.</p>

      {!data?.hasSessions ? (
        <div className="text-center py-12 text-sm text-muted-foreground bg-muted/30 rounded-lg border border-border">
          No session activity logged yet — this fills in as learners open lessons and their session data is tracked.
        </div>
      ) : (
        <IncidentHeatmapReportCard
          title="Engagement Heatmap"
          statItems={data?.statItems}
          metricItems={metricItemsWithIcons}
          heatmapData={data?.heatmapData}
          rangeOptions={RANGE_OPTIONS}
          selectedRange={range}
          onRangeChange={setRange}
        />
      )}
    </div>
  )
}

export default EngagementHeatmapSection